import { toRaw as e } from "vue";
import { unpackDetectChangesProxy as t } from "@scalar/workspace-store/helpers/detect-changes-proxy";
//#region src/schema/helpers/unwrap-for-read.ts
var n = (n) => t(e(n));
//#endregion
export { n as unwrapForRead };

//# sourceMappingURL=unwrap-for-read.js.map